<template>
    <div class="border border-gray-400 px-3 sm:px-6 pb-8 mt-2 mt-8 sm:-mt-px mb-8">
        <final-plat-has
            v-model="final_plat_is_required"
            :read_only="read_only"
        />

        <div v-if="final_plat_is_required">
            <final-plat-date
                :commercial="commercial"
                :read_only="read_only"
            />

            <final-plat-who-pays
                :commercial="commercial"
                :read_only="read_only"
            />

            <final-plat-review-dates
                :commercial="commercial"
                :read_only="read_only"
            />
        </div>
    </div>
</template>

<script>
import FinalPlatHas from './final-plat-has.vue';
import FinalPlatDate from './final-plat-date.vue';
import FinalPlatWhoPays from './final-plat-who-pays.vue';
import FinalPlatReviewDates from './final-plat-review-dates.vue';

export default {
    components: {
        FinalPlatHas,
        FinalPlatDate,
        FinalPlatWhoPays,
        FinalPlatReviewDates,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },

    data() {
        return {
            final_plat_is_required: this.commercial.final_plat_is_required,
        }
    },
}
</script>
